import { Controller } from "@hotwired/stimulus"
import { patch } from "@rails/request.js"
import Sortable from "sortablejs"

export default class extends Controller {
  static targets = ["column", "container", "count"]

  connect() {
    this.sortables = []
    this.observers = []
    this.initializeSortables()
    this.observeColumnChanges()
  }

  disconnect() {
    this.sortables.forEach(sortable => sortable.destroy())
    this.sortables = []
    this.observers.forEach(observer => observer.disconnect())
    this.observers = []
  }

  initializeSortables() {
    this.containerTargets.forEach(container => {
      const sortable = Sortable.create(container, {
        group: "tasks",
        animation: 150,
        ghostClass: "opacity-50",
        chosenClass: "shadow-lg",
        dragClass: "cursor-grabbing",
        draggable: ".task-card",
        onEnd: this.handleSortEnd.bind(this)
      })
      this.sortables.push(sortable)
    })
  }

  observeColumnChanges() {
    this.containerTargets.forEach(container => {
      const observer = new MutationObserver(() => this.updateColumnCounts())
      observer.observe(container, { childList: true })
      this.observers.push(observer)
    })
  }

  updateColumnCounts() {
    this.columnTargets.forEach(column => {
      const container = column.querySelector('[data-task-kanban-target="container"]')
      const countEl = column.querySelector('[data-task-kanban-target="count"]')
      if (container && countEl) {
        const count = container.querySelectorAll(".task-card").length
        countEl.textContent = count
      }
    })
  }

  async handleSortEnd(event) {
    const cardElement = event.item
    const taskId = cardElement.dataset.taskId
    const newStatus = event.to.dataset.status
    const newPosition = event.newIndex

    if (event.from === event.to && event.oldIndex === event.newIndex) return

    try {
      const response = await patch(`/workspace/tasks/${taskId}/move`, {
        body: JSON.stringify({
          status: newStatus,
          position: newPosition
        }),
        contentType: "application/json",
        responseKind: "json"
      })

      if (!response.ok) {
        console.error("Failed to move task")
        window.location.reload()
      }
    } catch (error) {
      console.error("Error moving task:", error)
      window.location.reload()
    }
  }
}
